import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { NavLink } from 'react-router-dom'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { getLastUnreadItem } from 'state/selectors/chatSelectors'
import { getCurrentUser, isCurrentUserAdmin } from 'state/selectors/userSelectors'

import { 
    openModal, 
    openHeaderTab, 
    closeChat,
} from 'state/actions'

import {
    toggleMobileControls
} from 'utils'

class MobileFooter extends Component {
    constructor(props) {
        super(props)

        this.routes = [
            {
                icon: 'fe-layout',
                path: 'dashboard',
                isSelected: _ => {
                    return this.isSelected('dashboard')
                },
            }, {
                icon: 'fe-mail',
                path: 'chats',
                isTab: true,
                isSelected: _ => {
                    return this.isSelected('chats')
                },
            }, {
                icon: 'star',
                path: 'projects',
                isSelected: _ => {
                    return this.isSelected('projects')
                },
            }, {
                icon: 'fe-bell',
                path: 'notifications',
                isTab: true,
                isSelected: _ => {
                    return this.isSelected('notifications')
                },
                callback: _ => {
                    this.clickTab('notifications')
                }
            }, {
                icon: 'check-square-o',
                path: 'todos',
                isTab: true,
                isSelected: _ => {
                    return this.isSelected('todos')
                },
            }
        ]
    }

    isSelected = route => {
        const { path, isTab } = route

        if(this.props.activeChats && this.props.activeChats.length){
            return path == 'chats'
        }else if (isTab) {
            return this.props.activeHeaderTab == path
        } else {
            return this.props.location.pathname.includes(path) && !this.props.activeHeaderTab
        }
    }

    clickTab = route => {
        const { 
            path, 
            isTab 
        } = route

        const {
            activeChats,
            allChats,
            openHeaderTab,
            history,
            match,
            closeChat
        } = this.props

        toggleMobileControls(true)

        if(true){
            if(activeChats && activeChats.length){
                activeChats.forEach(chat => {
                    let chatObject = allChats[chat.id]
                    closeChat(chatObject, 0)
                })
            }
        }

        if (isTab) {
            openHeaderTab(path)
        } else {
            openHeaderTab(null)

            // I dunno man, sometimes it just doesn't...
            setTimeout(_ => {
                history.push(match.url + '/' + path)

                setTimeout(_ => {
                    history.push(match.url + '/' + path)
                },1)
            },1)
        }
    }

    hasNotificationsCheck = route => {
        const {
            userData,
            allNotifications,
            allChats,
            entities
        } = this.props

        let alertCount = 0

        switch (route.path) {
            case 'notifications':

                if (!userData.notifications) {
                    return false
                }

                let alertables = userData.notifications.filter(notificationId => {
                    let notificationObject = allNotifications[notificationId]

                    return notificationObject.has_seen === null
                });

                alertCount = alertables.length
                break
            case 'messages':
                if (!this.props.userData.chats) {
                    return false
                }

                userData.chats.forEach(chatId => {
                    let chatObject = allChats[chatId];

                    if (chatObject) {
                        if (getLastUnreadItem(chatObject, userData, entities)) {
                            alertCount++
                        }
                    }
                })

                alertCount
                break
        }

        return alertCount
    }

    render() {
        const {
            userData
        } = this.props

        if(!userData){
            return null
        }

        let className = 'mobile-only'

        return (
            <footer id="mobile-footer" className={className}>
                <ul>
                    {
                        this.routes.map((route, index) => {
                            const alertCount = this.hasNotificationsCheck(route)

                            return (
                                <li key={index}>
                                    <a 
                                        className={this.isSelected(route) ? 'active' : null} 
                                        href="javascript:void(0)" 
                                        onClick={_ => { this.clickTab(route) }}
                                    >
                                        <i className={alertCount ? "alert visible" : "alert"}>
                                            { alertCount }
                                        </i>
                                        <Icon name={route.icon} />
                                    </a>
                                </li>
                            )
                        })
                    }
                </ul>
            </footer>
        )
    }
}


const mapStateToProps = state => {
    return {
        activeChats: state.auth.activeChats,
        userData: getCurrentUser(state),
        allChats: state.account.entities.chats,
        allMessages: state.account.entities.messages,
        allVersions: state.account.entities.versions,
        allNotifications: state.account.entities.notifications,
        activeHeaderTab: state.account.activeHeaderTab,
        entities: state.account.entities,
        keyboardHeight: state.account.keyboardHeight,
    };
}

export default withRouter(connect(mapStateToProps, { 
    openModal, 
    openHeaderTab,
    closeChat,
})(MobileFooter))


// WEBPACK FOOTER //
// ./src/components/mobile/mobile-footer.jsx